import axios from 'axios';

export async function setNewPassword(cell, pass, token) {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + '/api/users/users/reset_password/',
      data: {
        token: token, phone_number: cell, password: pass,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}
